export default {
  "errors": {
    "notFound": "Evento non trovato.",
    "disabled": "Le conferme di partecipazione (RSVP) online non sono abilitate per questo evento.",
    "loadError": "Impossibile caricare la pagina.",
    "searchError": "Non siamo riusciti a trovare il tuo invito. Verifica l'ortografia esatta utilizzata sul tuo invito.",
    "genericError": "Si è verificato un errore.",
    "submitError": "Errore durante l'invio della risposta."
  },
  "success": {
    "title": "Grazie!",
    "message": "La tua risposta è stata registrata con successo.",
    "dateMessage": "Ci vediamo il {{date}}!"
  },
  "header": {
    "title": "Conferma Partecipazione",
    "defaultWelcome": "Non vediamo l'ora di festeggiare con te! Ti preghiamo di confermare la tua presenza."
  },
  "search": {
    "title": "Trova il tuo invito",
    "firstName": "Nome",
    "firstNamePlaceholder": "Mario",
    "lastName": "Cognome",
    "lastNamePlaceholder": "Rossi (Facoltativo)",
    "submit": "Cerca",
    "searching": "Ricerca in corso..."
  },
  "form": {
    "greeting": "Ciao, {{firstName}} {{lastName}}!",
    "subtitle": "Ti preghiamo di farci sapere se sarai con noi.",
    "attendance": "Parteciperai?",
    "yes": "Sì, con piacere!",
    "no": "No, mi dispiace",
    "plusOne": {
      "title": "Il tuo accompagnatore (+1)",
      "label": "Nome e Cognome dell'accompagnatore",
      "placeholder": "Giulia Bianchi"
    },
    "dietary": {
      "title": "Esigenze alimentari",
      "subtitle": "Seleziona le opzioni che ti riguardano (e il tuo accompagnatore, se applicabile).",
      "vegetarian": "Vegetariano",
      "vegan": "Vegano",
      "glutenFree": "Senza Glutine",
      "porkFree": "Senza carne di maiale",
      "nutAllergy": "Allergia alla frutta a guscio",
      "seafoodAllergy": "Allergia ai frutti di mare",
      "customPlaceholder": "Altri dettagli (allergie specifiche...)"
    },
    "message": {
      "title": "Un messaggio per gli sposi?",
      "placeholder": "Lascia un dolce pensiero..."
    },
    "submit": "Conferma la mia risposta",
    "submitting": "Conferma in corso..."
  }
};
